import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  durationHours: number;
  tone?: 'dark' | 'light';
  size?: 'md' | 'sm';
}
export function Countdown({
  durationHours,
  tone = 'dark',
  size = 'md'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(durationHours);
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  const box = tone === 'dark' ? 'bg-forest-950/70 text-cream-50 ring-1 ring-inset ring-gold-400/30' : 'bg-cream-100 text-forest-900 ring-1 ring-inset ring-forest-900/10';
  const isSmall = size === 'sm';
  return <div className="flex items-end justify-center gap-1.5 sm:gap-3" role="timer" aria-live="off" data-id="element-49" data-mp="372jdqzfq4hqq">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-50" data-mp="10degjf978lpy" data-mpi={index}>
          <div className="text-center" data-id="element-51" data-mp="10aim40wk8f69">
            <div className={`rounded-lg font-display tabular-nums sm:rounded-xl ${box} ${isSmall ? 'min-w-[2.4rem] px-2 py-1 text-lg' : 'min-w-[3.1rem] px-2.5 py-2 text-2xl sm:min-w-[4.5rem] sm:px-3 sm:py-2.5 sm:text-4xl'}`} style={{
          fontWeight: 700,
          color: "#090A09",
          backgroundColor: "#EFEF28",
          backgroundImage: "none"
        }} data-id="element-52" data-mp="15boh65dp0eiy">
              {unit.value}
            </div>
            {!isSmall ? <div className={`mt-1 text-[0.58rem] font-semibold uppercase tracking-[0.12em] sm:mt-1.5 sm:text-[0.65rem] sm:tracking-[0.15em] ${tone === 'dark' ? 'text-cream-200/70' : 'text-forest-900/60'}`} data-id="element-53" data-mp="12rmxkry2fnc0">
                {unit.label}
              </div> : null}
          </div>
          {index < units.length - 1 ? <span className={`font-display ${isSmall ? 'pb-0.5 text-base' : 'pb-5 text-lg sm:pb-7 sm:text-2xl'} ${tone === 'dark' ? 'text-gold-400/60' : 'text-forest-900/30'}`} data-id="element-54" data-mp="k15ivra2is9n">
              :
            </span> : null}
        </React.Fragment>)}
    </div>;
}